// extracted by mini-css-extract-plugin
module.exports = {"Filter":"Filter_Filter__13gOn","Filters":"Filter_Filters__1OQRe","slide":"Filter_slide__3PKN2"};